<template>
  <section class="temple-loading-icon">
    <div></div>
    <div>
      <div></div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'LoadingIcon',
  props: {},
  data() {
    return {};
  },
  computed: {},
  methods: {},
  components: {},
};
</script>

<style lang="scss" scoped>
  @keyframes temple-loading-icon {
    0% {
      -webkit-transform: rotate(0);
      transform: rotate(0);
    }
    100% {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }

  @-webkit-keyframes temple-loading-icon {
    0% {
      -webkit-transform: rotate(0);
      transform: rotate(0);
    }
    100% {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }

  .temple-loading-icon {
    position: absolute;
    left: 50%;
    top: 50%;
    width: 50px !important;
    height: 50px !important;
    transform: translate(-50%, -50%) scale(0.25) translate(-50%, -50%);

    div {
      box-sizing: border-box;
    }

    > div {
      position: absolute;
      width: 176px;
      height: 176px;
      top: 12px;
      left: 12px;
      border-radius: 50%;
      border: 16px solid #000;
      border-color: $color-circle-bg transparent $color-circle-bg transparent;
      -webkit-animation: temple-loading-icon 1s linear infinite;
      animation: temple-loading-icon 1s linear infinite;

      &:nth-child(2) {
        border-color: transparent;

        div {
          position: absolute;
          width: 100%;
          height: 100%;
          -webkit-transform: rotate(45deg);
          transform: rotate(45deg);

          &::before,
          &::after {
            content: '';
            display: block;
            position: absolute;
            width: 16px;
            height: 16px;
            top: -16px;
            left: 64px;
            background: $color-circle-bg;
            border-radius: 50%;
            box-shadow: 0 160px 0 0 $color-circle-bg;
          }

          &::after {
            left: -16px;
            top: 64px;
            box-shadow: 160px 0 0 0 $color-circle-bg;
          }
        }
      }
    }
  }
</style>
